import { ROUNDING_MODE_OPTIONS } from '#/utils/roundingMode';
import { formatDisplayNumber } from '#/utils/formatNumber';

/** 數量、單價、列金額最多四位小數；總額為取整後 TWD 整數。 */
export function formatQuotationDecimal(value) {
  return formatDisplayNumber(value, { maximumFractionDigits: 4 });
}

export function formatQuotationTotal(value) {
  return formatDisplayNumber(value);
}

export function formatQuotationCustomer(customer) {
  if (!customer) {
    return '-';
  }
  return [customer.code, customer.name].filter(Boolean).join(' - ') || '-';
}

export function formatQuotationRoundingMode(value) {
  return ROUNDING_MODE_OPTIONS.find((option) => option.value === value)?.label ?? (value || '-');
}
